export default __webpack_public_path__ + "static/media/bike_card_3.d4b737bf.png";